/**
 * 概览（Overview）—— 登录后 landing 页。
 *
 * docs/platform-refactor-v1.md §1.3 决策 2：
 *   登录后跳 /overview,页面上有明显的"跳到规控/感知"入口。
 *
 * 结构 (自上而下):
 *   页面顶栏: 右上角「刷新」按钮 (手动刷新, 一次同时刷全部区块)
 *   ↓
 *   全平台运营看板 (DashboardSection) — 一块统一面板:
 *     ① 平台指标带: 累计任务 / 里程 (hero) + 今日新增 (accent)
 *     ② 运行趋势折线 (日 / 周 / 月 / 历史累计)
 *     ③ 按仿真类型实时状态: PNC / 感知 各含 4 状态格 (排队/编译/执行/已完成) + CTA
 *     数据源: GET /sim-dashboard/summary + /trend + GET /overview/simtype-runtime
 *   ↓
 *   项目 · 资源占用 — 两张项目卡 (simulation / simulation-gpu)
 *     数据源: GET /project/overview/resources
 *     详见 docs/overview-project-resource.md
 *
 * 刷新策略: 用一个 refreshToken 数字, 每按一次「刷新」就 +1;各 Section
 * 都把它当 useEffect 依赖, 变化即重拉一次接口。挂载首次 = token=0 触发首拉。
 */
import { useCallback, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import ProjectResourceSection from './ProjectResourceSection';
import DashboardSection, { DEFAULT_SIM_TYPES } from './DashboardSection';

export default function OverviewPage() {
  const navigate = useNavigate();
  const [refreshToken, setRefreshToken] = useState(0);
  const [lastRefreshedAt, setLastRefreshedAt] = useState<Date | null>(null);

  const handleRefresh = useCallback(() => {
    setRefreshToken((v) => v + 1);
    setLastRefreshedAt(new Date());
  }, []);

  const simTypes = useMemo(() => DEFAULT_SIM_TYPES(navigate), [navigate]);

  return (
    <div style={{ padding: '24px 32px', maxWidth: 1360, margin: '0 auto' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: 12,
          marginBottom: 12,
        }}
      >
        {lastRefreshedAt && (
          <span style={{ color: '#8c8c8c', fontSize: 12 }}>
            上次刷新 {lastRefreshedAt.toLocaleTimeString()}
          </span>
        )}
        <Button icon={<ReloadOutlined />} onClick={handleRefresh}>
          刷新
        </Button>
      </div>

      <DashboardSection refreshToken={refreshToken} simTypes={simTypes} />

      <ProjectResourceSection refreshToken={refreshToken} />
    </div>
  );
}
